import { useEffect } from "react";

const BASE_URL = "https://www.afinsurancegroup.com";
const DEFAULT_TITLE = "A&F Insurance Group, Inc. | Commercial Property & Business Insurance - Fort Lauderdale, Florida";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      const path = window.location.pathname;
      canonical.setAttribute("href", `${BASE_URL}${path === "/" ? "/" : path}`);
    }
    return () => {
      document.title = DEFAULT_TITLE;
      if (canonical) canonical.setAttribute("href", `${BASE_URL}/`);
    };
  }, [title, description]);
}
